// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2GlCY","choiceBoxes":"toolbarselects_choiceBoxes__3213Z","simpleField":"toolbarselects_simpleField__msCxb"};